var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinningRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M27.588 8.537c.563-.82 1.631-1.357 1.635-3.007L28.882.658c-.006-.192-.162-.345-.354-.345-.19-.001-.348.151-.356.343v4.871h-.563l-.16-4.873c-.005-.192-.161-.345-.353-.345-.19 0-.348.151-.355.343l-.183 4.872-.564-.002.024-4.872c-.006-.191-.162-.344-.354-.344-.19-.001-.348.15-.355.343l-.366 4.871c-.003 1.649 1.062 2.192 1.62 3.014 0 0-.478 12.797-.482 14.543 0 .089.005.176.015.26 0 .01-.003.018-.003.028 0 .272.116.517.3.69.115.124.266.209.456.243.032.007.066.008.1.01.03.003.056.01.088.01h.007c.067 0 .133-.008.197-.021.123-.023.228-.07.32-.133l.03-.021c.024-.019.05-.039.072-.061.202-.175.331-.43.331-.717 0-.026-.005-.05-.007-.073.006-.068.012-.137.012-.208.004-1.746-.41-14.547-.41-14.547M2.276 11.183L2.31 1.03c0-.305-.036-.597-.094-.785C2.198.189 2.17.143 2.133.107 2.063.036 1.963.001 1.858 0 .86-.003.028 2.042.018 5.486L0 11.176c0 .314.126.598.33.805.044.043.09.083.139.12L.176 23.04c-.001.013-.004.023-.004.036l.002.022-.002.078s.004.01.013.023c.053.403.359.722.755.791.044.01.094.017.157.017h.001c.066 0 .129-.008.19-.02.193-.034.343-.12.457-.246.02-.019.036-.04.053-.061.011-.014.023-.024.033-.039.12-.156.194-.35.194-.565.014-.098.023-.199.023-.304l-.247-10.669c.285-.206.474-.54.475-.92",
    transform: "translate(.495 .387)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M24.37 12.939c0 5.544-4.403 10.038-9.835 10.038-5.433 0-9.836-4.494-9.836-10.038C4.699 7.395 9.102 2.9 14.535 2.9c5.432 0 9.836 4.495 9.836 10.039",
    transform: "translate(.495 .387)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A8254",
    strokeWidth: 0.769,
    d: "M14.535 21.052c4.447 0 8.065-3.64 8.065-8.113 0-4.473-3.618-8.113-8.065-8.113-4.447 0-8.065 3.64-8.065 8.113 0 4.473 3.618 8.113 8.065 8.113z",
    transform: "translate(.495 .387)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinningRoom);
export default __webpack_public_path__ + "static/media/dinning_room.96c55d0f302af0fb8941c4b377e90bea.svg";
export { ForwardRef as ReactComponent };